import * as yup from 'yup';

import type { TTableName } from 'infrastructure/interfaces';

const ccmConsoleTableNoteValidationSchema = yup.object().shape({
  note: yup
    .object()
    .shape({
      date: yup.string(),
      text: yup.string(),
      author: yup.string(),
    })
    .nullable(),
  patientGuid: yup.string().optional(),
  patientName: yup.string().optional(),
  tableName: yup
    .string()
    .oneOf<TTableName>(['follow-up', 'newly', 'partials'])
    .optional(),
});

const ccmConsoleWorkQueueValidationSchema = yup.object().shape({
  guid: yup.string().required(),
  name: yup.string().required(),
  dueDate: yup.string().nullable(),
  tableName: yup
    .string()
    .oneOf<TTableName>(['follow-up', 'newly', 'partials'])
    .required(),
  notes: yup.array(ccmConsoleTableNoteValidationSchema.optional().nullable()),
});

export const ccmConsoleStoreValidationSchema = yup.object().shape({
  tableNote: ccmConsoleTableNoteValidationSchema.optional(),
  isOpenDrawer: yup.boolean().required(),
  workQueue: yup.array().of(ccmConsoleWorkQueueValidationSchema).required(),
});
